import { call, put, takeLatest } from "redux-saga/effects"
import { GET_LIST_COUNT_QUESTIONS_WATCHER } from "./constants"
import {
  getListCountQuestionsSuccess,
  getListCountQuestionsFailed,
} from "./actions"
import api from "../../../utils/api"
import { TYPE_FETCHING } from "../../../utils/constants"
import { validate } from "../../../utils/functions"

function getListCountQuestionsApi(payload) {
  const segmentParam = !validate.empty(payload.id_segment)
    ? `&id_segment=${payload.id_segment}`
    : ""
  return api(
    `reports/measure/${payload.id_measure}/questions/amounts?f${segmentParam}`,
    TYPE_FETCHING.get,
    { id_segment: payload.id_segment }
  )
}

export function* getListCountQuestionsSaga(action) {
  try {
    const data = yield call(getListCountQuestionsApi, action.payload)
    yield put(getListCountQuestionsSuccess(data))
  } catch (e) {
    yield put(getListCountQuestionsFailed())
  }
}

export default function* summaryQuestionsSaga() {
  yield takeLatest(GET_LIST_COUNT_QUESTIONS_WATCHER, getListCountQuestionsSaga)
}
